<!--立项销售-->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <!-- 搜索-->
      <dynamic-search
        v-show="showSearch"
        :data="tableFilterList(tableHead)"
        @search="dynamicSearch"
      >
        <template v-slot:next>
          <el-button icon="el-icon-plus" @click="$router.push('')">新增</el-button>
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="tableData"
        :config="{trigger: 'click', mode: 'cell'}"
        :editable="true"
        :total="200"
        :offset="20"
        :page="5"
      ></edit-data-table>
    </el-card>
  </div>
</template>

<script>

  import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import dataTableMixin from "@/mixin/dataTableMixin";

  export default {
    name: "PartnerBudgetTask",
     mixins: [dataTableMixin],
    components: {
      DynamicSearch,
    },
    data() {
      return {
        tableHead: [
           {
              label: '项目名',
              prop: 'name',
              query: {
                type: 'input'
              },
              align: 'left'
            }, {
              label: '立项类型',
              prop: 'type'
            }, {
              label: '项目负责人',
              prop: 'person',
            }, {
              label: '计划成单日期',
              prop: 'susscessdate',
            }
        ],
        tableData: [
          {
          name: 45,
          type: "名字11",
          person: "111100",
          susscessdate: "666666",
        },
        ]
      };
    },
    methods: {
      // 新增合伙人预算任务
      add() {
        this.$router.push('setup/add')
      }
    }
  }
</script>

<style scoped lang="scss">
  .dashboard-editor-container {
    height: 100%;
    padding: 32px;
    background-color: rgb(240, 242, 245);
    position: relative;

    .github-corner {
      position: absolute;
      top: 0px;
      border: 0;
      right: 0;
    }

    .chart-wrapper {
      background: #fff;
      padding: 16px 16px 0;
      margin-bottom: 32px;
    }
  }

  @media (max-width: 1024px) {
    .chart-wrapper {
      padding: 8px;
    }
  }
</style>
